import { Component } from '@angular/core';

@Component({
    selector: 'app-experience-tab-root',
    templateUrl: './experience-tab-root.component.html',
    styleUrls: ['./experience-tab-root.component.scss'],
})
export class ExperienceTabRootComponent {}
